// Note-option and standardized-section api fns — carved verbatim from
// `src/api/scribeAPIV2.ts` / `src/api/scribeAPIV2_1.ts` (both of which now
// re-export them) as D1 of the `integrations/ehr` family (ARCFE-1087).
//
// `getIntegrationAvailableStandardizedSections` and its `…V21` sibling send the
// SAME route with the SAME params to DIFFERENT base URLs (`/api/v2/ml-scribe/`
// vs `/api/v2-1/ml-scribe/`). That is why the transport seam exposes two
// accessors and why these two live side by side rather than one delegating to
// the other.
import type {
  GetAvailableStandardizedSectionsResponse,
  GetCernerNoteTypesResponse,
  GetNoteOptionsResponse,
} from '../../contracts/types';
import { http, httpV2_1 } from './ehrHttp';

import type { EHRProvider } from '@heidi/schema/ml-scribe';

export const getNoteOptionsForIntegration = ({ sessionId }: { sessionId: string }) => {
  return http().get<GetNoteOptionsResponse>(
    `/integrations/session/${sessionId}/note-options`
  );
};

export const getCernerNoteTypes = ({ sessionId }: { sessionId: string }) => {
  return http().get<GetCernerNoteTypesResponse>(
    `/integrations/session/${sessionId}/cerner/note-types`
  );
};

export const getAvailableEhrSections = ({
  ehrProvider,
}: {
  ehrProvider: EHRProvider;
}) => {
  return http().get<GetAvailableStandardizedSectionsResponse>(
    `/ehr/uploader/available-standardized-sections`,
    {
      params: {
        provider: ehrProvider,
      },
    }
  );
};

export const getIntegrationAvailableStandardizedSections = ({
  onboardingSessionId,
}: {
  onboardingSessionId: string;
}) => {
  return http().get<GetAvailableStandardizedSectionsResponse>(
    `/integrations/standardized-sections`,
    { params: { onboarding_session_id: onboardingSessionId } }
  );
};

export const getIntegrationAvailableStandardizedSectionsV21 = ({
  onboardingSessionId,
}: {
  onboardingSessionId: string;
}) => {
  return httpV2_1().get<GetAvailableStandardizedSectionsResponse>(
    `/integrations/standardized-sections`,
    { params: { onboarding_session_id: onboardingSessionId } }
  );
};
